export const CARRIER_ID = 'CARRIER_ID';
